/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class WhatsappConnectionAPI extends ApiClient {
  constructor() {
    super('loco/inboxes', { accountScoped: true });
  }

  path(inboxId, action = '') {
    return `${this.url}/${inboxId}/whatsapp_connection${action ? `/${action}` : ''}`;
  }

  status(inboxId) {
    return axios.get(this.path(inboxId));
  }

  connect(inboxId, pairingPhone) {
    return axios.post(this.path(inboxId, 'connect'), {
      pairing_phone: pairingPhone || undefined,
    });
  }

  logout(inboxId) {
    return axios.post(this.path(inboxId, 'logout'));
  }

  updateSettings(inboxId, settings) {
    return axios.patch(this.path(inboxId, 'settings'), { settings });
  }

  // Imports the chats of the last `days` days kept by the gateway
  importHistory(inboxId, days) {
    return axios.post(this.path(inboxId, 'import_history'), { days });
  }

  checkNumbers(inboxId, numbers) {
    return axios.post(this.path(inboxId, 'check_numbers'), { numbers });
  }

  switchProvider(inboxId, provider, providerConfig) {
    return axios.post(this.path(inboxId, 'switch_provider'), {
      provider,
      provider_config: providerConfig,
    });
  }
}

export default new WhatsappConnectionAPI();
